import { Skill } from '../../../../interfaces/Skill.interface';
import typescriptIcon from '../images/typescript-icon-min.png';
import gitIcon from '../images/git-icon-min.png';
import htmlIcon from '../images/html-icon-min.png';
import ccsIcon from '../images/css-icon-min.png';
import jiraIcon from '../images/jira-icon-min.png';
import javascriptIcon from '../images/javascript-icon-one-min.png';
import reactIcon from '../images/react-icon-min.png';
import springBootIcon from '../images/spring-boot-icon-min.png';
import javaIcon from '../images/java-icon-min.png';
import sqlIcon from '../images/sql-icon-min.png';
import dockerIcon from '../images/docker-icon-min.png';
import postgreSqlIcon from '../images/postgresql-icon-min.png';
import angularIcon from '../images/angular-icon-min.png';
import dotNetIcon from '../images/dotNet-icon-min.png';
import cSharpIcon from '../images/cSharp-icon-min.svg';
import mySqlIcon from '../images/mySql-icon-min.png';

export const skills: Skill[] = [
  {
    name: 'Typescript',
    image: typescriptIcon,
  },
  {
    name: 'Javascript',
    image: javascriptIcon,
  },
  {
    name: 'HTML',
    image: htmlIcon,
  },
  {
    name: 'CSS',
    image: ccsIcon,
  },
  {
    name: 'Jira/Agile',
    image: jiraIcon,
  },
  {
    name: 'Git',
    image: gitIcon,
  },
  {
    name: 'React',
    image: reactIcon,
  },
  {
    name: 'Spring boot',
    image: springBootIcon,
  },
  {
    name: 'Java',
    image: javaIcon,
  },
  {
    name: 'SQL/Relational databases',
    image: sqlIcon,
  },
  {
    name: 'Docker',
    image: dockerIcon,
  },
  {
    name: 'PostgreSQL',
    image: postgreSqlIcon,
  },
  {
    name: 'Angular',
    image: angularIcon,
  },
  {
    name: 'ASP.NET',
    image: dotNetIcon,
  },
  {
    name: 'C#',
    image: cSharpIcon,
  },
  {
    name: 'MySql',
    image: mySqlIcon,
  },
];
